/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
 * ------------------------------------------------------------------------------------------------------------
 * [CUSTOM] HUCKLEBERRY SUBSCRIPTION — ĐỒNG BỘ LABEL OPTION KHI ĐỔI VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * Đi kèm với thay đổi trong assets/theme.js (đã bỏ "variant-picker" khỏi partial re-render để widget
 * Huckleberry không bị mất listener). Vì theme không còn tự thay mới <variant-picker>, chữ hiển thị của
 * option đã chọn (.product-form__option-value / .select__selected-value) không tự cập nhật nữa, nên đoạn
 * dưới cập nhật lại thủ công dựa trên radio đang được chọn.
 *
 * LƯU Ý: KHÔNG bắn lại sự kiện 'change' lên radio option ở đây — theme lắng nghe 'change' qua delegation
 * trên document.body, làm vậy sẽ gây vòng lặp re-render vô hạn.
 */
(function () {
  function syncSelectedOptionLabels() {
    document.querySelectorAll('variant-picker .product-form__option-selector').forEach(function (selector) {
      var checked = selector.querySelector('input[data-option-position]:checked');
      var valueEl = selector.querySelector('.product-form__option-value, .select__selected-value');
      if (!checked || !valueEl) return;

      var label = selector.querySelector('label[for="' + checked.id + '"]');
      var text = label ? label.textContent.trim() : '';
      if (text) valueEl.textContent = text;
    });
  }

  document.addEventListener('variant:changed', function () {
    // Đợi theme hoàn tất việc thay các block partial re-render rồi mới cập nhật label.
    requestAnimationFrame(syncSelectedOptionLabels);
  });
})();

/**
 * ------------------------------------------------------------------------------------------------------------
 * [CUSTOM] HUCKLEBERRY — CHỐNG RACE KHI ĐỔI VARIANT (debounced re-sync)
 * ------------------------------------------------------------------------------------------------------------
 *
 * Widget Huckleberry CÓ cập nhật theo variant, nhưng xử lý bất đồng bộ. Đổi variant quá nhanh khiến các lần
 * cập nhật đua nhau (race) và widget kẹt ở plan sai. Sau khi ngừng đổi một nhịp ngắn, đoạn dưới bắn lại tín
 * hiệu variant (variant:changed + change trên input[name="id"]) để Huckleberry đồng bộ về variant CUỐI CÙNG.
 * Cũng chạy vài lần sau khi load để xử lý trường hợp mở link deep-link có ?variant=.
 *
 * AN TOÀN: Focal KHÔNG lắng nghe 'variant:changed' để re-render (chỉ nghe 'product:rerender'), và KHÔNG nghe
 * 'change' của input[name="id"] -> việc bắn lại các tín hiệu này không gây vòng lặp re-render của theme.
 * Cờ `resyncing` chặn đệ quy từ chính tín hiệu mình bắn ra.
 */
(function () {
  var RESYNC_DELAY = 600; // ms kể từ lần đổi variant cuối cùng
  var timer = null;
  var resyncing = false;

  function currentForm() {
    var vp = document.querySelector('variant-picker');
    return vp ? (document.forms[vp.getAttribute('form-id')] || null) : null;
  }

  function forceResync(form) {
    form = form || currentForm();
    if (!form) return;

    resyncing = true;
    try {
      // 1) Re-fire 'change' trên input variant id (node bền; theme không nghe -> không loop).
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.dispatchEvent(new Event('change', { bubbles: true }));

      // 2) Bắn lại 'variant:changed' với variant hiện tại, đọc từ getter công khai của theme.
      var formId = form.getAttribute('id');
      var vp = document.querySelector('variant-picker[form-id="' + formId + '"]') || document.querySelector('variant-picker');
      var variant = vp ? vp.selectedVariant : null;

      form.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: { formId: formId, variant: variant }
      }));
    } finally {
      resyncing = false;
    }
  }

  document.addEventListener('variant:changed', function (event) {
    if (resyncing) return; // bỏ qua tín hiệu do chính mình bắn lại
    var form = event.target;
    clearTimeout(timer);
    timer = setTimeout(function () { forceResync(form); }, RESYNC_DELAY);
  });

  // Sau khi load: đồng bộ vài nhịp để chờ widget Huckleberry mount xong (xử lý ?variant=).
  window.addEventListener('load', function () {
    [800, 2000].forEach(function (delay) {
      setTimeout(function () { forceResync(); }, delay);
    });
  });
})();

/**
 * ------------------------------------------------------------------------------------------------------------
 * [CUSTOM] HUCKLEBERRY — ĐỒNG BỘ GIÁ HIỂN THỊ THEO GÓI ĐỊNH KỲ ĐANG CHỌN
 * ------------------------------------------------------------------------------------------------------------
 *
 * VẤN ĐỀ: snippets/product-info.liquid của Focal chỉ in `variant.price` (giá mua 1 lần). Khi khách chọn một
 * gói định kỳ trong widget Huckleberry, giá ở đầu trang sản phẩm không đổi -> không khớp với giá trong widget.
 *
 * GIẢI PHÁP: product-info.liquid xuất một bảng JSON (data-subscription-price-data) chứa giá của từng
 * selling plan cho mỗi variant (từ `variant.selling_plan_allocations`). Đoạn dưới đọc gói đang chọn và cập
 * nhật lại `.price-list` (product-meta) + `.product-sticky-form__price` cho khớp.
 *
 * VÌ SAO NGHE THEO DÕI DOM: widget Huckleberry set `input[name="selling_plan"]` bằng JS (React) và KHÔNG phát
 * event 'change' chuẩn, nên ta vừa bắt 'change'/'click' trong khối sản phẩm, vừa MutationObserver khối đó để
 * cập nhật lại giá. render có guard (chỉ ghi khi HTML khác) nên không gây vòng lặp observer.
 * Nguồn sự thật cho gói đang chọn là `input[name="selling_plan"]` trong form add-to-cart (giá trị gửi lên cart).
 */
(function () {
  var applyTimer = null;

  function getData() {
    var el = document.querySelector('[data-subscription-price-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function mainForm() {
    return document.querySelector('form.shopify-product-form[action$="/cart/add"]')
        || document.querySelector('form[action$="/cart/add"]');
  }

  function currentVariantId() {
    var vp = document.querySelector('variant-picker');
    if (vp && vp.selectedVariant && vp.selectedVariant.id) return String(vp.selectedVariant.id);
    var form = mainForm();
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    return idInput && idInput.value ? String(idInput.value) : null;
  }

  // Rỗng = mua 1 lần (dùng giá gốc). Khác rỗng = id selling plan đang chọn.
  function selectedPlanId() {
    var form = mainForm();
    var sp = form ? form.querySelector('input[name="selling_plan"]') : null;
    if (sp) return sp.value ? String(sp.value) : '';
    var checked = document.querySelector('input[name="planOption"]:checked');
    return checked && checked.value ? String(checked.value) : '';
  }

  function priceInfoFor(data) {
    var vId = currentVariantId();
    var v = vId && data.variants ? data.variants[vId] : null;
    if (!v) return null;
    var planId = selectedPlanId();
    if (planId && v.plans && v.plans[planId]) return v.plans[planId];
    return v.base;
  }

  function priceListMarkup(info, labels) {
    var onSale = info.compareAt && info.compareAt > info.price;
    if (onSale) {
      return '<span class="price price--highlight price--large"><span class="visually-hidden">' + (labels.sale || '') + '</span>' + info.priceHtml + '</span>'
           + '<span class="price price--compare"><span class="visually-hidden">' + (labels.regular || '') + '</span>' + info.compareAtHtml + '</span>';
    }
    return '<span class="price price--large"><span class="visually-hidden">' + (labels.sale || '') + '</span>' + info.priceHtml + '</span>';
  }

  /**
   * Patch giá hiển thị trên từng dòng plan TRONG widget Huckleberry.
   * Widget render giá của ĐƠN ĐẦU TIÊN (allocation.price) — khi có khuyến mãi 初回無料
   * (giảm 100% đơn đầu) thì thành ¥0. Dòng plan nên hiển thị giá mỗi kỳ giao
   * (allocation.per_delivery_price) nên ta ghi đè lại phần tử <p>¥...</p> trong label.
   * Chỉ patch khi perDelivery > 0 và KHÁC giá đơn đầu (tức có ưu đãi đơn đầu);
   * React re-render sẽ bị MutationObserver bên dưới patch lại ngay.
   */
  function patchWidgetPrices(data) {
    var vId = currentVariantId();
    var v = vId && data.variants ? data.variants[vId] : null;
    if (!v || !v.plans) return;

    document.querySelectorAll('.huckleberry-subscription-widget-container label[for]').forEach(function (label) {
      var plan = v.plans[label.getAttribute('for')];
      if (!plan || !(plan.perDelivery > 0) || plan.perDelivery === plan.price) return;

      label.querySelectorAll('p').forEach(function (p) {
        var t = (p.textContent || '').trim();
        // Chỉ đụng vào phần tử là "giá" thuần (ví dụ ¥0 / ¥39,000), không đụng tên/mô tả plan.
        if (/^[¥￥][\d,.]+$/.test(t) && p.innerHTML !== plan.perDeliveryHtml) {
          p.innerHTML = plan.perDeliveryHtml;
        }
      });
    });
  }

  function apply() {
    var data = getData();
    if (!data) return;
    patchWidgetPrices(data);
    var info = priceInfoFor(data);
    if (!info) return;
    var labels = data.labels || {};

    // 1) Giá chính trong product-meta (giữ nguyên khối unit price nếu có).
    var priceList = document.querySelector('product-meta .price-list');
    if (priceList) {
      var unit = priceList.querySelector('.unit-price-measurement');
      var unitWrap = unit ? unit.closest('.price') : null;
      var html = priceListMarkup(info, labels) + (unitWrap ? unitWrap.outerHTML : '');
      if (priceList.innerHTML !== html) priceList.innerHTML = html;
    }

    // 2) Giá ở thanh sticky add-to-cart (nếu bật).
    document.querySelectorAll('.product-sticky-form__price').forEach(function (el) {
      if (el.innerHTML !== info.priceHtml) el.innerHTML = info.priceHtml;
    });
  }

  function scheduleApply() {
    clearTimeout(applyTimer);
    applyTimer = setTimeout(apply, 120);
  }

  function init() {
    if (!getData()) return; // sản phẩm không có gói định kỳ -> bỏ qua.

    var container = document.querySelector('product-info') || document.querySelector('.product') || document.body;

    new MutationObserver(scheduleApply).observe(container, {
      childList: true, subtree: true, characterData: true
    });

    container.addEventListener('change', scheduleApply);
    container.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.huckleberry-subscription-widget-container')) scheduleApply();
    });

    // Đổi variant (sản phẩm nhiều biến thể): Focal re-render khối "meta" -> áp lại sau khi swap xong.
    document.addEventListener('variant:changed', function () {
      [0, 250, 600].forEach(function (d) { setTimeout(apply, d); });
    });

    apply();
    [400, 1000, 2000].forEach(function (d) { setTimeout(apply, d); }); // chờ widget Huckleberry mount xong.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();